import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ClienteInternacional } from "../models/ClienteInternacional/ClienteInternacional";
import { ClienteInternacionalFilter } from "../models/ClienteInternacional/ClienteInternacionalFilter";
import { Page } from "../shared/models/Page";
import { PagedResponse } from "../shared/models/PagedResponse";
import { Response } from "../shared/models/Response";

@Injectable({
   providedIn: "root",
})
export class ClienteInternacionalService {
   private REST_API_SERVER = environment.backend_server + "/ClienteInternacional";

   constructor(private http: HttpClient) {}

   getDataByPage(filtro: ClienteInternacionalFilter, page: Page): Observable<PagedResponse<ClienteInternacional>> {
      let razonSocial = filtro.razonSocial != undefined ? filtro.razonSocial : "";
      let giro = filtro.giro ? filtro.giro : "";
      let emisorId = filtro.emisorId ? filtro.emisorId : "";
      let pais = filtro.paisId ? filtro.paisId : "";
      let activo = filtro.activo;
      let codigoInterno = filtro.codigoInterno != null ? filtro.codigoInterno : "";
      return this.http.get<PagedResponse<ClienteInternacional>>(this.REST_API_SERVER + "/list/filter" + "?razonSocial=" + razonSocial + "&giro=" + giro + "&paisId=" + pais + "&EmisorId=" + emisorId + "&activo=" + activo + "&codigoInterno=" + codigoInterno + "&pageNumber=" + page.pageNumber + "&pageSize=" + page.pageSize);
   }

   sendClientRequest(clientRequest: ClienteInternacional): Observable<Response<ClienteInternacional>> {
      return this.http.post<Response<ClienteInternacional>>(this.REST_API_SERVER + "/add", clientRequest);
   }

   deactivateClient(clienteId): Observable<Response<boolean>> {
      return this.http.get<Response<boolean>>(this.REST_API_SERVER + "/deactivate/" + clienteId);
   }

   reactivateClient(clientId): Observable<Response<boolean>> {
      return this.http.get<Response<boolean>>(this.REST_API_SERVER + "/activate/" + clientId);
   }

   editClientRequest(clienteId, clientRequest: ClienteInternacional) {
      return this.http.post<Response<ClienteInternacional>>(this.REST_API_SERVER + "/update", clientRequest);
   }

   searchClient(pattern: string, emisorId: string): Observable<Response<ClienteInternacional[]>> {
      return this.http.get<Response<ClienteInternacional[]>>(this.REST_API_SERVER + "/buscar?pattern=" + pattern + "&emisorId=" + emisorId);
   }
}
